import QrFormView from "./QrFormView";

function QrForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  return (
    <QrFormView
      setPrinterData={setPrinterData}
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      submitError={submitError}
    />
  );
}

export default QrForm;
